module.exports = function() {
  return new Worker(__webpack_public_path__ + "1d7c7fede006c1277d80.worker.js");
};